/**
 * createElement
 * @param {string} text 
 * @returns {HtmlElement} item
 */
function createElement(text) {
    let item = document.createElement('li');
    let anch = document.createElement('a');
    let txt = document.createTextNode(text);
    let hrf = document.createAttribute('href');
    let tab = document.createAttribute('tabindex');

    hrf.value = "#";
    tab.value = 0;
    anch.setAttributeNode(hrf);
    anch.setAttributeNode(tab);
    anch.appendChild(txt);
    item.appendChild(anch);

    return item;
}

/**
 * emptyNode
 * @param {HtmlElement} obj 
 */
function emptyNode(obj) {
    while (obj.hasChildNodes()) {
        obj.removeChild(obj.firstChild);
    }
}

/**
 * simulateKeydownEvent
 * @param {string} key 
 * @param {HtmlElement} obj 
 */
function simulateKeydownEvent(key, obj) {
    const keys = {
        tab: {
            key: "Tab",
            keycode: 9
        }
    };

    let event = new KeyboardEvent("keydown", {
        bubbles: true,
        key: keys[key].key,
        keyCode: keys[key].keycode,
    });

    obj.dispatchEvent(event);
}

/**
 * getFormByElement
 * @param {object} el
 * @return {object} form
 */
function getFormByElement(el) {
    let node = el;
    while (node.tagName.toLowerCase() !== "form" && node.tagName.toLowerCase() !== "body") {
        node = node.parentNode;
    }
    return node;
}


export {
    createElement,
    emptyNode,
    getFormByElement,
    simulateKeydownEvent
};